import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Download_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.25 17C4.25 16.5858 4.58579 16.25 5 16.25L15 16.25C15.4142 16.25 15.75 16.5858 15.75 17C15.75 17.4142 15.4142 17.75 15 17.75L5 17.75C4.58579 17.75 4.25 17.4142 4.25 17ZM4.46967 9.53033C4.17678 9.23744 4.17678 8.76256 4.46967 8.46967C4.76256 8.17678 5.23744 8.17678 5.53033 8.46967L9.25 12.1893L9.25 3C9.25 2.58579 9.58579 2.25 10 2.25C10.4142 2.25 10.75 2.58579 10.75 3L10.75 12.1893L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967C15.8232 8.76256 15.8232 9.23743 15.5303 9.53033L10.5303 14.5303C10.3897 14.671 10.1989 14.75 10 14.75C9.80109 14.75 9.61032 14.671 9.46967 14.5303L4.46967 9.53033Z"
            />
        </SvgStyled>
    );
};

export default Download_sm;
